import { portsCategoryData } from "@components/templates/Profile/ProfileHeader/profile-enum";
import styles from "./MapCategory.module.scss";

const MapCategory = ({ categoryData, activeCategory, handleCategoryClick, countDetails, showTradeLane }) => {
  return (
    <div className={styles.mapCategoryContainer}>
      <span>Plot map for</span>
      {categoryData && categoryData?.length > 0 ? (
        <div className={styles.categories}>
          {categoryData.map((category) =>
            category?.countEnum ? (
              countDetails[category.countEnum] ? (
                <div key={category.id} className={`${styles.category} ${activeCategory === category.id && styles.activeCategory}`} onClick={() => handleCategoryClick(category)}>
                  <input type="radio" id={category.id} name={category.value} value={category.value} checked={activeCategory === category.id} className={styles.radioButton} />
                  <label htmlFor={category.id}>{category.value}</label>
                </div>
              ) : null
            ) : (
              !(category.id === portsCategoryData[0].id && !showTradeLane) && (
                <div key={category.id} className={`${styles.category} ${activeCategory === category.id && styles.activeCategory}`} onClick={() => handleCategoryClick(category)}>
                  <input type="radio" id={category.id} name={category.value} value={category.value} checked={activeCategory === category.id} className={styles.radioButton} />
                  <label htmlFor={category.id}>{category.value}</label>
                </div>
              )
            )
          )}
        </div>
      ) : null}
    </div>
  );
};

export default MapCategory;
